export const ApplicationLinks = {
    Documentation: {
        CompetitiveSet: {
            id: 'competitive_set_documentation',
            href: `/`,
        },
    },
};
